import React, { useState } from "react";
import axios from "axios";

// interface Application {
//   success: boolean;
//   name: string;
//   post_id?: number;
//   resumeUrl?: string;
// }

const JobApplicationForm = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [resumeFile, setResumeFile] = useState<File | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [statusMessage, setStatusMessage] = useState<string>("");

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setResumeFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!resumeFile) {
      setStatusMessage("Error: Could not find file");
      return;
    }

    setLoading(true);
    setStatusMessage("Submitting...");

    const formData = new FormData();
    formData.append("applicant_name", name);
    formData.append("applicant_email", email);
    formData.append("resume_file", resumeFile, resumeFile.name);

    try {
      const response = await axios.post(
        "/wp-json/v1/application/submit",
        formData
      );

      setStatusMessage(response.data.message);

      setName("");
      setEmail("");
      setResumeFile(null);
      const fileInput = document.getElementById(
        "resume-file-input"
      ) as HTMLInputElement;
      if (fileInput) fileInput.value = "";
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        // Now TypeScript knows error.response exists and has a data property
        const apiError = err.response.data;
        setStatusMessage(
          `Error: ${apiError.message || "Something went wrong."}`
        );
      } else {
        setStatusMessage("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <title>We're Hiring! - NDSU Spectrum</title>
      <meta
        name="description"
        content="Join the team at NDSU Spectrum. Explore career opportunities and apply today."
      />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl shadow-md border border-gray-100">
          <h2 className="text-3xl font-heading font-bold mb-8 text-center text-gray-900">Job Application</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Your Name</label>
              <input
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition-all"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Your Email</label>
              <input
                type="email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition-all"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2" htmlFor="resume-file-input">
                Resume (PDF or DOCX)
              </label>
              <div className="relative">
                <input
                  type="file"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition-all file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
                  id="resume-file-input"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx"
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-white text-green-700 border-2 border-green-700 font-bold py-3 rounded-md transition-all duration-200 hover:bg-green-700 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Application"}
            </button>
          </form>

          {statusMessage && (
            <div className={`mt-6 p-4 rounded-md text-center font-medium ${statusMessage.startsWith('Error') ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
              {statusMessage}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default JobApplicationForm;
